module.exports = __webpack_public_path__ + "img/sfcc-logo-white.svg";